<template>
	<div class="app-wrapper" :class="classObj">
		
		<div class="main-container">
			<navbar></navbar>		
			<app-main></app-main>
			<foot></foot>
		</div>
	</div>
</template>

<script>
	
	import AppMain from '@/views/layout/components/AppMain'
import Navbar from '@/views/layout/components/Navbar'
	import Foot from '../layout/components/Foot.vue'
	
	import ResizeMixin from '@/views/layout/mixin/ResizeHandler'


	export default {
		name: 'Layout',
		data() {
			return {
				isCollapse: false,
				hideSidebar: false
			}
		},
		components: {		
			AppMain,
			Navbar,
			Foot
		
		},
		mixins: [ResizeMixin],//混入 (mixins) 是一种分发 Vue 组件中可复用功能的非常灵活的方式。混入对象可以包含任意组件选项。当组件使用混入对象时，所有混入对象的选项将被混入该组件本身的选项。
		methods: {

		},
		computed: {
			classObj() {
				return {
					//hideSidebar: this.hideSidebar
				}
			}
		},
		created() {
			//this.$store.dispatch('GetUserInfoByUsername', 'admin');
		}
	}
</script>
<style>
#app .hideSidebar {
    display: none;
}
</style>
<style scoped>
 .main-container {
 	-webkit-transition: margin-left .28s;
 	-moz-transition:margin-left .28s;
 	margin-left: 0px;
 	min-height: 100%;
 	position: relative;
 	transition: margin-left .28s;
 	width: 100%;
 }
 .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
}
.app-wrapper:after {
    content: "";
    display: table;
    clear: both;
}

#app .hideSidebar .main-container {
    margin-left: 54px;
    width: calc(100% - 54px);
}


</style>